import { React, useEffect, useState } from "react";
import KeyboardArrowRightIcon from "@mui/icons-material/ArrowForwardIos";
import MDTypography from "components/MDTypography";
import { TextField } from "@mui/material";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

function MultiSelectTreeView(props) {
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    // Toggle Nav
    const toggler = document.getElementsByClassName("caret");

    // Convert HTMLCollection to an array
    const togglerArray = Array.from(toggler);

    for (const element of togglerArray) {
      element.addEventListener("click", function (event) {
        const nested =
          event.currentTarget.parentElement.querySelector(".nested");
        if (nested) {
          // Check if nested is not null
          nested.classList.toggle("active");
        }
        event.currentTarget.classList.toggle("caret-down");
      });
    }
  }, []);

  const handleInputChange = (e) => {
    setSearchTerm(e.target.value);
    props.searchedData(e.target.value);
  };

  return (
    <>
      <TextField
        className="outlined-basic-subject search-doc my-2"
        placeholder="Search..."
        value={searchTerm}
        onChange={handleInputChange}
        // autoComplete="off"
      />

      <MDTypography
        variant="p"
        fontSize="13px"
        fontWeight="regular"
        fontFamily="inherit"
        color="white"
      >
        <li className=" docs-nav ver-nav">
          <span className="caret caret-down">
            <a href="#versions">
              <MDTypography
                variant="h6"
                fontSize="13px"
                fontWeight="regular"
                fontFamily="inherit"
              >
                <div data-to-scrollspy-id="versions">
                  FIX Specifications (Version 3.5)
                  <KeyboardArrowRightIcon />
                </div>
              </MDTypography>
            </a>
          </span>
          <ul className="docs-nav nested active">
            <li>
              <span className="caret">
                <a href="#introduction">
                  <MDTypography
                    variant="h6"
                    fontSize="13px"
                    fontWeight="regular"
                    fontFamily="inherit"
                  >
                    <div data-to-scrollspy-id="introduction">
                      Introduction
                      <KeyboardArrowRightIcon />
                    </div>
                  </MDTypography>
                </a>
              </span>
              <ul className="nested">
                <li>
                  <a href="#overview">
                    <span className="caret">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="overview">Overview</div>
                      </MDTypography>
                    </span>
                  </a>
                </li>
                <li>
                  <span className="caret">
                    <a href="#data-type">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="data-Type">
                          Data Type
                          <KeyboardArrowRightIcon />
                        </div>
                      </MDTypography>
                    </a>
                  </span>
                  <ul className="nested">
                    <li>
                      <a href="#timestamps">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            <div data-to-scrollspy-id="timestamps">
                              Timestamps
                            </div>
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a href="#message-format">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            <div data-to-scrollspy-id="message-format">
                              Message Format
                            </div>
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a href="#sequence-numbers">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            <div data-to-scrollspy-id="sequence-numbers">
                              Sequence Numbers
                            </div>
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a href="#fix-engine-downtime">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            <div data-to-scrollspy-id="fix-engine-downtime">
                              Fix Engine downtime
                            </div>
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a href="#version-compatibility">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            <div data-to-scrollspy-id="version-compatibility">
                              Version Compatibility
                            </div>
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                  </ul>
                </li>
                <li>
                  <span className="caret">
                    <a href="#supported-messages">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="supported-messages">
                          Supported Messages
                          <KeyboardArrowRightIcon />
                        </div>
                      </MDTypography>
                    </a>
                  </span>
                  <ul className="nested">
                    <li>
                      <a href="#session-messages">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            <div data-to-scrollspy-id="session-messages">
                              Session Messages
                            </div>
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a href="#message-header">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            <div data-to-scrollspy-id="message-header">
                              Message Header
                            </div>
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a href="#message-trailer">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            <div data-to-scrollspy-id="message-trailer">
                              Message Trailer
                            </div>
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a href="#logon-message-35-A">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            <div data-to-scrollspy-id="logon-message-35-A">
                              Logon Message (35=A)
                            </div>
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a href="#heartbeat-35-0">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            <div data-to-scrollspy-id="heartbeat-35-0">
                              Heartbeat (35=0)
                            </div>
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a href="#test-request-35-1">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            <div data-to-scrollspy-id="test-request-35-1">
                              Test Request (35=1)
                            </div>
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a href="#resend-request-35-2">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            <div data-to-scrollspy-id="resend-request-35-2">
                              Resend Request (35=2)
                            </div>
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a href="#message-reject-35-3">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            <div data-to-scrollspy-id="message-reject-35-3">
                              Message Reject (35=3)
                            </div>
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a href="#sequence-reset-35-4">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            <div data-to-scrollspy-id="sequence-reset-35-4">
                              Sequence Reset (35=4)
                            </div>
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a href="#logout-35-5">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            <div data-to-scrollspy-id="logout-35-5">
                              Logout (35=5)
                            </div>
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a href="#application-message">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            <div data-to-scrollspy-id="application-message">
                              Application Message
                            </div>
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
            <li>
              <span className="caret">
                <a href="#equities">
                  <MDTypography
                    variant="h6"
                    fontSize="13px"
                    fontWeight="regular"
                    fontFamily="inherit"
                  >
                    <div data-to-scrollspy-id="equities">
                      Equities
                      <KeyboardArrowRightIcon />
                    </div>
                  </MDTypography>
                </a>
              </span>
              <ul className="nested">
                <li>
                  <a href="#equities-new-order-single-35-d">
                    <span className="caret">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="equities-new-order-single-35-d">
                          New Order Single (35=D)
                        </div>
                      </MDTypography>
                    </span>
                  </a>
                </li>
                <li>
                  <a href="#equities-order-cancel-replace-request-35-g">
                    <span className="caret">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="equities-order-cancel-replace-request-35-g">
                          Order Cancel / Replace Request (35=G)
                        </div>
                      </MDTypography>
                    </span>
                  </a>
                </li>
                <li>
                  <a href="#equities-order-cancel-request-35-f">
                    <span className="caret">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="equities-order-cancel-request-35-f">
                          Order Cancel Request (35=F)
                        </div>
                      </MDTypography>
                    </span>
                  </a>
                </li>
                <li>
                  <a href="#equities-execution-report-35-8">
                    <span className="caret">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="equities-execution-report-35-8">
                          Execution Report (35=8)
                        </div>
                      </MDTypography>
                    </span>
                  </a>
                </li>
                <li>
                  <a href="#equities-order-cancel-reject-35-9">
                    <span className="caret">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="equities-order-cancel-reject-35-9">
                          Order Cancel Reject (35=9)
                        </div>
                      </MDTypography>
                    </span>
                  </a>
                </li>
              </ul>
            </li>

            <li>
              <span className="caret">
                <a href="#equities-algo-vlet">
                  <MDTypography
                    variant="h6"
                    fontSize="13px"
                    fontWeight="regular"
                    fontFamily="inherit"
                  >
                    <div data-to-scrollspy-id="equities-algo-vlet">
                      Equities Algos (VLET)
                      <KeyboardArrowRightIcon />
                    </div>
                  </MDTypography>
                </a>
              </span>
              <ul className="nested">
                <li>
                  <a href="#equities-algo-vlet-new-order-single-35-d">
                    <span className="caret">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="equities-algo-vlet-new-order-single-35-d">
                          New Order Single (35=D)
                        </div>
                      </MDTypography>
                    </span>
                  </a>
                </li>
                <li>
                  <a href="#equities-algo-vlet-order-cancel-replace-request-35-g">
                    <span className="caret">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="equities-algo-vlet-order-cancel-replace-request-35-g">
                          Order Cancel / Replace Request (35=G)
                        </div>
                      </MDTypography>
                    </span>
                  </a>
                </li>
                <li>
                  <a href="#equities-algo-vlet-order-cancel-request-35-f">
                    <span className="caret">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="equities-algo-vlet-order-cancel-request-35-f">
                          Order Cancel Request (35=F)
                        </div>
                      </MDTypography>
                    </span>
                  </a>
                </li>
                <li>
                  <a href="#equities-algo-vlet-execution-report-35-8">
                    <span className="caret">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="equities-algo-vlet-execution-report-35-8">
                          Execution Report (35=8)
                        </div>
                      </MDTypography>
                    </span>
                  </a>
                </li>
                <li>
                  <a href="#equities-algo-vlet-order-cancel-reject-35-9">
                    <span className="caret">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="equities-algo-vlet-order-cancel-reject-35-9">
                          Order Cancel Reject (35=9)
                        </div>
                      </MDTypography>
                    </span>
                  </a>
                </li>
                <li>
                  <a href="#equities-algo-vlet-vlet-algo-sheet">
                    <span className="caret">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="equities-algo-vlet-vlet-algo-sheet">
                          VLET Algo Sheet
                        </div>
                      </MDTypography>
                    </span>
                  </a>
                </li>
              </ul>
            </li>
            <li>
              <span className="caret">
                <a href="#fractions">
                  <MDTypography
                    variant="h6"
                    fontSize="13px"
                    fontWeight="regular"
                    fontFamily="inherit"
                  >
                    <div data-to-scrollspy-id="fractions">
                      Fractions
                      <KeyboardArrowRightIcon />
                    </div>
                  </MDTypography>
                </a>
              </span>
              <ul className="nested">
                <li>
                  <a href="#fractions-new-order-single-35-d">
                    <span className="caret">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="fractions-new-order-single-35-d">
                          New Order Single (35=D)
                        </div>
                      </MDTypography>
                    </span>
                  </a>
                </li>
                <li>
                  <a href="#fractions-order-cancel-request-35-f">
                    <span className="caret">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="fractions-order-cancel-request-35-f">
                          Order Cancel Request (35=F)
                        </div>
                      </MDTypography>
                    </span>
                  </a>
                </li>
                <li>
                  <a href="#fractions-execution-report-35-8">
                    <span className="caret">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="fractions-execution-report-35-8">
                          Execution Report (35=8)
                        </div>
                      </MDTypography>
                    </span>
                  </a>
                </li>
                <li>
                  <a href="#fractions-order-cancel-reject-35-9">
                    <span className="caret">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="fractions-order-cancel-reject-35-9">
                          Order Cancel Reject (35=9)
                        </div>
                      </MDTypography>
                    </span>
                  </a>
                </li>
              </ul>
            </li>
            <li>
              <span className="caret">
                <a href="#options–singleleg">
                  <MDTypography
                    variant="h6"
                    fontSize="13px"
                    fontWeight="regular"
                    fontFamily="inherit"
                  >
                    <div data-to-scrollspy-id="options–singleleg">
                      Options – SingleLeg
                      <KeyboardArrowRightIcon />
                    </div>
                  </MDTypography>
                </a>
              </span>
              <ul className="nested">
                <li>
                  <a href="#options–singleleg-new-order-single-35-d">
                    <span className="caret">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="options–singleleg-new-order-single-35-d">
                          New Order Single (35=D)
                        </div>
                      </MDTypography>
                    </span>
                  </a>
                </li>
                <li>
                  <a href="#options–singleleg-order-cancel-request-replace-request-35-g">
                    <span className="caret">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="options–singleleg-order-cancel-request-replace-request-35-g">
                          Order Cancel / Replace Request (35=G)
                        </div>
                      </MDTypography>
                    </span>
                  </a>
                </li>
                <li>
                  <a href="#options–singleleg-order-cancel-request-35-f">
                    <span className="caret">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="options–singleleg-order-cancel-request-35-f">
                          Order Cancel Request (35=F)
                        </div>
                      </MDTypography>
                    </span>
                  </a>
                </li>
                <li>
                  <a href="#options–singleleg-execution-report-35-8">
                    <span className="caret">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="options–singleleg-execution-report-35-8">
                          Execution Report (35=8)
                        </div>
                      </MDTypography>
                    </span>
                  </a>
                </li>
                <li>
                  <a href="#options–singleleg-order-cancel-reject-35-9">
                    <span className="caret">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="options–singleleg-order-cancel-reject-35-9">
                          Order Cancel Reject (35=9)
                        </div>
                      </MDTypography>
                    </span>
                  </a>
                </li>
              </ul>
            </li>
            <li>
              <span className="caret">
                <a href="#options–multileg">
                  <MDTypography
                    variant="h6"
                    fontSize="13px"
                    fontWeight="regular"
                    fontFamily="inherit"
                  >
                    <div data-to-scrollspy-id="options–multileg">
                      Options – MultiLeg
                      <KeyboardArrowRightIcon />
                    </div>
                  </MDTypography>
                </a>
              </span>
              <ul className="nested">
                <li>
                  <a href="#options–multileg-new-order-multileg-35-ab">
                    <span className="caret">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="options–multileg-new-order-multileg-35-ab">
                          New Order MultiLeg (35=AB)
                        </div>
                      </MDTypography>
                    </span>
                  </a>
                </li>
                <li>
                  <a href="#options–multileg-order-cancel-replace-35-ac">
                    <span className="caret">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="options–multileg-order-cancel-replace-35-ac">
                          Multileg Order Cancel/Replace (35=AC)
                        </div>
                      </MDTypography>
                    </span>
                  </a>
                </li>
                <li>
                  <a href="#options–multileg-order-cancel-request-35-f">
                    <span className="caret">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="options–multileg-order-cancel-request-35-f">
                          Order Cancel Request (35=F)
                        </div>
                      </MDTypography>
                    </span>
                  </a>
                </li>
                <li>
                  <a href="#options–multileg-execution-report-35-8">
                    <span className="caret">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="options–multileg-execution-report-35-8">
                          Execution Report (35=8)
                        </div>
                      </MDTypography>
                    </span>
                  </a>
                </li>
                <li>
                  <a href="#options–multileg-order-cancel-reject-35-9">
                    <span className="caret">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="options–multileg-order-cancel-reject-35-9">
                          Order Cancel Reject (35=9)
                        </div>
                      </MDTypography>
                    </span>
                  </a>
                </li>
              </ul>
            </li>
            <li>
              <span className="caret">
                <a href="#futures">
                  <MDTypography
                    variant="h6"
                    fontSize="13px"
                    fontWeight="regular"
                    fontFamily="inherit"
                  >
                    <div data-to-scrollspy-id="futures">
                      Futures
                      <KeyboardArrowRightIcon />
                    </div>
                  </MDTypography>
                </a>
              </span>
              <ul className="nested">
                <li>
                  <a href="#futures-new-order-multileg-35-d">
                    <span className="caret">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="futures-new-order-multileg-35-d">
                          New Order Single (35=D)
                        </div>
                      </MDTypography>
                    </span>
                  </a>
                </li>
                <li>
                  <a href="#futures-order-cancel-replace-request-35-g">
                    <span className="caret">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="futures-order-cancel-replace-request-35-g">
                          Order Cancel / Replace Request (35=G)
                        </div>
                      </MDTypography>
                    </span>
                  </a>
                </li>
                <li>
                  <a href="#futures-order-cancel-request-35-f">
                    <span className="caret">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="futures-order-cancel-request-35-f">
                          Order Cancel Request (35=F)
                        </div>
                      </MDTypography>
                    </span>
                  </a>
                </li>
                <li>
                  <a href="#futures-execution-report-35-8">
                    <span className="caret">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="futures-execution-report-35-8">
                          Execution Report (35=8)
                        </div>
                      </MDTypography>
                    </span>
                  </a>
                </li>
                <li>
                  <a href="#futures-order-cancel-reject-35-9">
                    <span className="caret">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="futures-order-cancel-reject-35-9">
                          Order Cancel Reject (35=9)
                        </div>
                      </MDTypography>
                    </span>
                  </a>
                </li>
              </ul>
            </li>
            <li>
              <span className="caret">
                <a href="#mutual-funds">
                  <MDTypography
                    variant="h6"
                    fontSize="13px"
                    fontWeight="regular"
                    fontFamily="inherit"
                  >
                    <div data-to-scrollspy-id="mutual-funds">
                      Mutual Funds
                      <KeyboardArrowRightIcon />
                    </div>
                  </MDTypography>
                </a>
              </span>
              <ul className="nested">
                <li>
                  <a href="#mutual-funds-new-order-35-d">
                    <span className="caret">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="mutual-funds-new-order-35-d">
                          New Order (35=D)
                        </div>
                      </MDTypography>
                    </span>
                  </a>
                </li>
                <li>
                  <a href="#mutual-funds-order-cancel-request-35-f">
                    <span className="caret">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="mutual-funds-order-cancel-request-35-f">
                          Order Cancel Request (35=F)
                        </div>
                      </MDTypography>
                    </span>
                  </a>
                </li>
                <li>
                  <a href="#mutual-funds-status-report-35-8">
                    <span className="caret">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="mutual-funds-status-report-35-8">
                          Status Report (35=8)
                        </div>
                      </MDTypography>
                    </span>
                  </a>
                </li>
                <li>
                  <a href="#mutual-funds-cancel-status-report-35-8">
                    <span className="caret">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="mutual-funds-cancel-status-report-35-8">
                          Cancel Status Report (35=8)
                        </div>
                      </MDTypography>
                    </span>
                  </a>
                </li>
                <li>
                  <a href="#mutual-funds-confirmation-full-fill">
                    <span className="caret">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="mutual-funds-confirmation-full-fill">
                          Confirmation (Full Fill)
                        </div>
                      </MDTypography>
                    </span>
                  </a>
                </li>
                <li>
                  <a href="#mutual-funds-general-considerations">
                    <span className="caret">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="mutual-funds-general-considerations">
                          General Considerations
                        </div>
                      </MDTypography>
                    </span>
                  </a>
                </li>
              </ul>
            </li>
            <li>
              <span className="caret">
                <a href="#dropcopies-noes-and-allocations">
                  <MDTypography
                    variant="h6"
                    fontSize="13px"
                    fontWeight="regular"
                    fontFamily="inherit"
                  >
                    <div data-to-scrollspy-id="dropcopies-noes-and-allocations">
                      Dropcopies (NOE’s) and Allocations
                      <KeyboardArrowRightIcon />
                    </div>
                  </MDTypography>
                </a>
              </span>
              <ul className="nested">
                <li>
                  <a href="#dropcopies-execution-report-35-8">
                    <span className="caret">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="dropcopies-execution-report-35-8">
                          Execution Report (35=8)
                        </div>
                      </MDTypography>
                    </span>
                  </a>
                </li>
                <li>
                  <a href="#dropcopies-allocation-message">
                    <span className="caret">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="dropcopies-allocation-message">
                          Allocation Message
                        </div>
                      </MDTypography>
                    </span>
                  </a>
                </li>
              </ul>
            </li>
            <li>
              <a href="#legal-notices">
                <span className="caret">
                  <MDTypography
                    variant="h6"
                    fontSize="13px"
                    fontWeight="regular"
                    fontFamily="inherit"
                  >
                    <div data-to-scrollspy-id="legal-notices">
                      Legal Notices
                    </div>
                  </MDTypography>
                </span>
              </a>
            </li>
          </ul>
        </li>
        <li className=" docs-nav ver-nav">
          <span className="caret">
            <Link to="/products/fix-Specifications-v3.2">
              <MDTypography
                variant="h6"
                fontSize="13px"
                fontWeight="regular"
                fontFamily="inherit"
              >
                <div data-to-scrollspy-id="version">
                  FIX Specifications (Version 3.2)
                  <KeyboardArrowRightIcon />
                </div>
              </MDTypography>
            </Link>
          </span>
        </li>
        {/* <MDTypography
            variant="h6"
            fontSize="13px"
            fontWeight="medium"
            fontFamily="inherit"
            className="nav-footer"
          >
            Trading API - 2.2.4
          </MDTypography> */}
      </MDTypography>
    </>
  );
}
// Define prop types for the component
MultiSelectTreeView.propTypes = {
  searchedData: PropTypes.func.isRequired,
};
export default MultiSelectTreeView;
